<template lang='pug'>
  el-card.ec-campagin-card(
    v-if='item.campaign_name'
    @click.native="openProject"
  )
    .card-title
      span {{ item.campaign_name }}
      //- img(
      //-   v-if="item.is_bypass"
      //-   src="@/umcc/assets/bypass.png"
      //- )
    hr.divider
    .label-container
      .star-label(
        v-for="(j, i) in item.star"
      ) {{ j.star_name }}
        span(v-if="i !== item.star.length - 1") |
</template>

<script>
export default {
  components: {},
  props: {
    item: {
      type: Object,
      default () {
        return {
          brand: []
        }
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    openProject () {
      this.$store.commit('unistar/setCampaignInfo', this.item)
      this.$router.push({
        path: '/unistar/campaign-overview'
      })
    }
  }
}
</script>

<style lang='stylus'>
.ec-campagin-card
  position relative
  .card-title
    font-size 16px
    display flex
    img
      position absolute
      height 20px
      right 0
      top 25px
    span
      width: 100%;
      text-overflow: ellipsis;
      word-break: keep-all;
      overflow: hidden;
      white-space nowrap
  .title-row
    color #bababa
    line-height 12px
    font-size 12px
  .content-row
    margin-bottom 12px
  .divider
    margin 12px 0 16px
    border 0.5px solid rgb(216, 216, 216)
  .label-container
    display flex
    flex-wrap wrap
    // justify-content space-around
    .star-label
      margin-bottom 12px
      color #3370d2
      span
        margin 0 10px
        color #d8d8d8
</style>
